import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import { pop } from 'rebook/apps/users/actions/NotificationActions';

import styles from './style.scss';


class ShelveScrollList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdded: false,
    };
  }

  componentDidMount() {
    if (this.props.bookDetail && this.props.bookDetail.userBookshelfList) {
      for (let shelve of this.props.bookDetail.userBookshelfList) {
        if (shelve.name === this.props.text) {
          this.setState({ isAdded: true });
          return true;
        }
      }
    }
  }

  addBookToShelve() {
    const { shelve, bookId, book, closeModal, gaEventLabel } = this.props;
    const isAudioBook = book.type === 'audio';
    let responseShelveName = this.cropShelveName(shelve.name);
    const popupMessage = {
      message: `${isAudioBook ? 'Аудиокнига' : 'Книга'} добавлена на полку "${responseShelveName}" `,
      type: 'thumbsUp',
    };
    const url = `/api/bookshelf/${shelve.id}/bookusershelf/`;
    const params = {
      json: {
        book: `/api/books/${bookId}/`,
      },
      apiVersion: 4,
      method: 'POST',
    };
    fetchQuery(url, params).then(() => {
      this.setState({ isAdded: true });
      this.props.BookDetailActions.fetchBookUserBookshelf(book);
      closeModal();
    }).then(() => {
      ga('send', 'event', {
        eventCategory: 'Shelves',
        eventAction: 'AddBookToShelf',
        eventLabel: gaEventLabel,
      });
      yaMetrikaReachGoal('AddBookToShelf');
    }).then(() => {
      const { message, type } = popupMessage;
      this.props.pop(message, type);
    }).catch((error) => {
      throw new Error(error);
    });
  }

  removeBookFromShelve() {
    const { shelve, bookId, book, closeModal, gaEventLabel } = this.props;
    const isAudioBook = book.type === 'audio';
    let responseShelveName = this.cropShelveName(shelve.name);
    const popupMessage = {
      message: `${isAudioBook ? 'Аудиокнига' : 'Книга'} удалена c полки "${responseShelveName}" `,
      type: 'removed',
    };
    const url = `/api/bookshelf/${shelve.id}/bookusershelf/?book=${bookId}`;
    const params = {
      apiVersion: 4,
      method: 'DELETE',
    };
    fetchQuery(url, params).then(() => {
      this.setState({ isAdded: false });
      this.props.BookDetailActions.fetchBookUserBookshelf(book);
      closeModal();
    }).then(() => {
      ga('send', 'event', {
        eventCategory: 'Shelves',
        eventAction: 'DeleteBookFromShelf',
        eventLabel: gaEventLabel,
      });
    }).then(() => {
      const { message, type } = popupMessage;
      this.props.pop(message, type);
    }).catch((error) => {
      throw new Error(error);
    });
  }

  cropShelveName(name) {
    const shelveNameLength = 100;
    if (name.length > shelveNameLength) {
      return name.slice(0, shelveNameLength) + '...';
    }
    return name;
  }

  render() {
    const { text, removeBookFromTheShelve } = this.props;
    return (
      <React.Fragment>
        {this.state.isAdded && removeBookFromTheShelve ?
          <div className={styles.scrollListPill}
            onClick={() => this.removeBookFromShelve()}>
            <span>{text}</span>
            <i className={styles.removeFromShelve} />
          </div> : null
        }

        {!removeBookFromTheShelve && !this.state.isAdded ?

          <div className={styles.scrollListPill}
            onClick={() => this.addBookToShelve()}>
            <span>{text}</span>
            <i className={styles.addToShelve} />
          </div> : null}
      </React.Fragment>
    );
  }
}

ShelveScrollList.propTypes = {
  shelve: PropTypes.object.isRequired,
  text: PropTypes.string,
  bookId: PropTypes.number.isRequired,
  bookDetail: PropTypes.object.isRequired,
  book: PropTypes.object.isRequired,
  closeModal: PropTypes.func,
  removeBookFromTheShelve: PropTypes.bool,
  gaEventLabel: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    bookDetail: state.bookDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
    pop: (message, type) => dispatch(pop(message, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShelveScrollList);
